module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.invalid
    }
  }, [_c('label', {
    staticClass: "trip-label"
  }, [_vm._v(_vm._s(_vm.campos.label) + ":")]), _vm._v(" "), _c('i', {
    class: _vm.campos.iconClass
  }), _vm._v(" "), (_vm.sequence == 0) ? _c('button', {
    staticClass: "btn btn-success btn-add-pin",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Adicionar um local de passagem"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('addPoint')
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-plus"
  })]) : (_vm.sequence != _vm.totalPoints - 1) ? _c('button', {
    staticClass: "btn btn-danger btn-del-pin",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Remover local de passagem"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('removePoint', _vm.sequence)
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-minus"
  })]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model),
      expression: "model"
    }],
    ref: "input",
    class: _vm.campos.inputClass,
    attrs: {
      "name": _vm.id,
      "id": _vm.id,
      "placeholder": _vm.campos.placeholder
    },
    domProps: {
      "value": (_vm.model)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model = $event.target.value
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-5a166c2f!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/routing/input-google-ac.vue
// module id = 2138
// module chunks = 1